import * as Types from '../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type WholeSyncableEpocusBillingFragment = { readonly __typename?: 'SyncableEpocusBilling', readonly id: string, readonly examId?: string | null, readonly encounterId: string, readonly dateOfService?: string | null, readonly patientMrn?: string | null, readonly patientDob?: string | null, readonly payerName?: string | null, readonly policyNumber?: string | null, readonly performingPhysicianName?: string | null, readonly performingPhysicianNpi?: string | null, readonly supervisingPhysicianNpi?: string | null, readonly facilityNpi?: string | null, readonly clinicalSetting?: Types.EpocusClinicalSetting | null, readonly billingMode?: Types.EpocusBillingMode | null, readonly procedureCodes: unknown, readonly diagnosisCodes: unknown, readonly documentationStatus?: Types.EpocusBillingDocumentationStatus | null, readonly imagesStored: boolean, readonly exportedAt?: string | null, readonly locked: boolean, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly updatedAt: string, readonly createdByUserId: string, readonly updatedByUserId: string, readonly deleted: boolean } };

export type SyncEpocusBillingPullQueryVariables = Types.Exact<{
  input: Types.PullEpocusBillingInput;
}>;


export type SyncEpocusBillingPullQuery = { readonly __typename?: 'Query', readonly pullEpocusBilling: { readonly __typename?: 'PullEpocusBillingResult', readonly checkpoint?: { readonly __typename?: 'SyncableCheckpoint', readonly id: string, readonly updatedAt: string } | null, readonly documents: ReadonlyArray<{ readonly __typename?: 'SyncableEpocusBilling', readonly id: string, readonly examId?: string | null, readonly encounterId: string, readonly dateOfService?: string | null, readonly patientMrn?: string | null, readonly patientDob?: string | null, readonly payerName?: string | null, readonly policyNumber?: string | null, readonly performingPhysicianName?: string | null, readonly performingPhysicianNpi?: string | null, readonly supervisingPhysicianNpi?: string | null, readonly facilityNpi?: string | null, readonly clinicalSetting?: Types.EpocusClinicalSetting | null, readonly billingMode?: Types.EpocusBillingMode | null, readonly procedureCodes: unknown, readonly diagnosisCodes: unknown, readonly documentationStatus?: Types.EpocusBillingDocumentationStatus | null, readonly imagesStored: boolean, readonly exportedAt?: string | null, readonly locked: boolean, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly updatedAt: string, readonly createdByUserId: string, readonly updatedByUserId: string, readonly deleted: boolean } }> } };

export type SyncEpocusBillingPushMutationVariables = Types.Exact<{
  input: Types.PushEpocusBillingInput;
}>;


export type SyncEpocusBillingPushMutation = { readonly __typename?: 'Mutation', readonly pushEpocusBilling: { readonly __typename?: 'PushEpocusBillingResult', readonly rows: ReadonlyArray<{ readonly __typename?: 'SyncableEpocusBilling', readonly id: string, readonly examId?: string | null, readonly encounterId: string, readonly dateOfService?: string | null, readonly patientMrn?: string | null, readonly patientDob?: string | null, readonly payerName?: string | null, readonly policyNumber?: string | null, readonly performingPhysicianName?: string | null, readonly performingPhysicianNpi?: string | null, readonly supervisingPhysicianNpi?: string | null, readonly facilityNpi?: string | null, readonly clinicalSetting?: Types.EpocusClinicalSetting | null, readonly billingMode?: Types.EpocusBillingMode | null, readonly procedureCodes: unknown, readonly diagnosisCodes: unknown, readonly documentationStatus?: Types.EpocusBillingDocumentationStatus | null, readonly imagesStored: boolean, readonly exportedAt?: string | null, readonly locked: boolean, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly updatedAt: string, readonly createdByUserId: string, readonly updatedByUserId: string, readonly deleted: boolean } }> } };

export const WholeSyncableEpocusBillingFragmentDoc = gql`
    fragment WholeSyncableEpocusBilling on SyncableEpocusBilling {
  id
  examId
  encounterId
  dateOfService
  patientMrn
  patientDob
  payerName
  policyNumber
  performingPhysicianName
  performingPhysicianNpi
  supervisingPhysicianNpi
  facilityNpi
  clinicalSetting
  billingMode
  procedureCodes
  diagnosisCodes
  documentationStatus
  imagesStored
  exportedAt
  locked
  meta {
    createdAt
    updatedAt
    createdByUserId
    updatedByUserId
    deleted
  }
}
    `;
export const SyncEpocusBillingPullDocument = gql`
    query SyncEpocusBillingPull($input: PullEpocusBillingInput!) {
  pullEpocusBilling(input: $input) {
    checkpoint {
      id
      updatedAt
    }
    documents {
      ...WholeSyncableEpocusBilling
    }
  }
}
    ${WholeSyncableEpocusBillingFragmentDoc}`;

/**
 * __useSyncEpocusBillingPullQuery__
 *
 * To run a query within a React component, call `useSyncEpocusBillingPullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSyncEpocusBillingPullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSyncEpocusBillingPullQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncEpocusBillingPullQuery(baseOptions: Apollo.QueryHookOptions<SyncEpocusBillingPullQuery, SyncEpocusBillingPullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SyncEpocusBillingPullQuery, SyncEpocusBillingPullQueryVariables>(SyncEpocusBillingPullDocument, options);
      }
export function useSyncEpocusBillingPullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SyncEpocusBillingPullQuery, SyncEpocusBillingPullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SyncEpocusBillingPullQuery, SyncEpocusBillingPullQueryVariables>(SyncEpocusBillingPullDocument, options);
        }
export type SyncEpocusBillingPullQueryHookResult = ReturnType<typeof useSyncEpocusBillingPullQuery>;
export type SyncEpocusBillingPullLazyQueryHookResult = ReturnType<typeof useSyncEpocusBillingPullLazyQuery>;
export type SyncEpocusBillingPullQueryResult = Apollo.QueryResult<SyncEpocusBillingPullQuery, SyncEpocusBillingPullQueryVariables>;
export const SyncEpocusBillingPushDocument = gql`
    mutation SyncEpocusBillingPush($input: PushEpocusBillingInput!) {
  pushEpocusBilling(input: $input) {
    rows {
      ...WholeSyncableEpocusBilling
    }
  }
}
    ${WholeSyncableEpocusBillingFragmentDoc}`;
export type SyncEpocusBillingPushMutationFn = Apollo.MutationFunction<SyncEpocusBillingPushMutation, SyncEpocusBillingPushMutationVariables>;

/**
 * __useSyncEpocusBillingPushMutation__
 *
 * To run a mutation, you first call `useSyncEpocusBillingPushMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncEpocusBillingPushMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncEpocusBillingPushMutation, { data, loading, error }] = useSyncEpocusBillingPushMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncEpocusBillingPushMutation(baseOptions?: Apollo.MutationHookOptions<SyncEpocusBillingPushMutation, SyncEpocusBillingPushMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncEpocusBillingPushMutation, SyncEpocusBillingPushMutationVariables>(SyncEpocusBillingPushDocument, options);
      }
export type SyncEpocusBillingPushMutationHookResult = ReturnType<typeof useSyncEpocusBillingPushMutation>;
export type SyncEpocusBillingPushMutationResult = Apollo.MutationResult<SyncEpocusBillingPushMutation>;
export type SyncEpocusBillingPushMutationOptions = Apollo.BaseMutationOptions<SyncEpocusBillingPushMutation, SyncEpocusBillingPushMutationVariables>;